import React, { useState } from 'react';
import { Button } from "../../../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../../../ui/dialog";
import { Input } from "../../../ui/input";
import { Label } from "../../../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../ui/select";
import { Textarea } from "../../../ui/textarea";

const RefundModal = ({ isOpen, onClose, onSubmit, transaction_id, description }) => {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [ticketNumber, setTicketNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const leadPurchaseId = parseInt(transaction_id.replace('lead-', ''), 10);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const payload = {
      lead_purchase_id: leadPurchaseId,
      reason,
      ticket_number: ticketNumber,
      notes,
      custom_reason: reason === "Other" ? customReason : null,
    };
    const success = await onSubmit(payload);
    setIsSubmitting(false);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Refund Lead Purchase</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="reason" className="text-right">Reason</Label>
              <Select onValueChange={setReason} required>
                <SelectTrigger className="col-span-3">
                  <SelectValue placeholder="Select a reason" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Lead Issue">Lead Issue</SelectItem>
                  <SelectItem value="Phone Number Issue">Phone Number Issue</SelectItem>
                  <SelectItem value="Buyer Changed Mind">Buyer Changed Mind</SelectItem>
                  <SelectItem value="Unverified Phone">Unverified Phone</SelectItem>
                  <SelectItem value="Other">Other</SelectItem>
                </SelectContent>
              </Select>
            </div>
            {reason === 'Other' && (
              <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="custom-reason" className="text-right">Custom Reason</Label>
                <Input id="custom-reason" value={customReason} onChange={(e) => setCustomReason(e.target.value)} className="col-span-3" required />
              </div>
            )}
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="ticket-number" className="text-right">Ticket Number</Label>
              <Input id="ticket-number" value={ticketNumber} onChange={(e) => setTicketNumber(e.target.value)} className="col-span-3" required />
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="notes" className="text-right">Notes</Label>
              <Textarea id="notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="col-span-3" />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={isSubmitting || !reason || !ticketNumber}>
              {isSubmitting ? "Submitting..." : "Confirm Refund"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RefundModal;